(function () {
    class HomeComponent {
        constructor(
            $scope,
            $state,
            PermissionService,
            DashboardConfig,
            ChatAssistantSelector
        ) {
            this.reportsURL = DashboardConfig.ReportioUrl;
            this.permissionService = PermissionService;
            this.dashboardConfig = DashboardConfig;
            this.$state = $state;
            this.$scope = $scope;
            this.initialise();
            void ChatAssistantSelector.connect();
        }

        getUrlFromState(state) {
            const userContext = this.permissionService.userContext;
            if (!userContext) {
                return;
            }
            const params = {
                storeId: userContext.StoreId,
                brandId: userContext.BrandId,
                callCenterId: userContext.CallCenterId
            };
            return this.$state.href(state, params);
        }

        loadCampaignUrls() {
            const brandCampaigns = "app.brandcampaigns";
            const storeCampaigns = "app.storecampaigns";
            const createBrandCampaignUrl = this.getUrlFromState(brandCampaigns);
            const createStoreCampaignUrl = this.getUrlFromState(storeCampaigns);
            this.createCampaignUrl = createBrandCampaignUrl || createStoreCampaignUrl;

            const scheduledBrandCampaignsUrl = this.getUrlFromState(`${ brandCampaigns }.scheduledcampaigns`);
            const scheduledStoreCampaignsUrl = this.getUrlFromState(`${ storeCampaigns }.scheduledcampaigns`);
            this.scheduledCampaignsUrl = scheduledBrandCampaignsUrl
                || scheduledStoreCampaignsUrl;

            const activeBrandCampaignsUrl = this.getUrlFromState(`${ brandCampaigns }.currentcampaigns`);
            const activeStoreCampaignsUrl = this.getUrlFromState(`${ storeCampaigns }.currentcampaigns`);
            this.activeCampaignsUrl = activeBrandCampaignsUrl
                || activeStoreCampaignsUrl;

            const completeBrandCampaignsUrl = this.getUrlFromState(`${ brandCampaigns }.finishedcampaigns`);
            const completeStoreCampaignsUrl = this.getUrlFromState(`${ storeCampaigns }.finishedcampaigns`);
            this.completedCampaignsUrl = completeBrandCampaignsUrl
                || completeStoreCampaignsUrl;

            const cancelledBrandCampaignsUrl = this.getUrlFromState(`${ brandCampaigns }.cancelledcampaigns`);
            const cancelledStoreCampaignsUrl = this.getUrlFromState(`${ storeCampaigns }.cancelledcampaigns`);
            this.cancelledCampaignsUrl = cancelledBrandCampaignsUrl
                || cancelledStoreCampaignsUrl;

            const userHasPermission = this.permissionService.doesUserHavePermissionForContext(
                Dashboard.Models.Lookups.Permissions.ManageCampaigns,
            );

            this.showCampaignsCard = userHasPermission && (this.createCampaignUrl
                || this.scheduledCampaignsUrl
                || this.activeCampaignsUrl
                || this.createCampaignUrl);
        }

        loadCampaignDesignerUrls() {
            const brandCampaignTemplates = "app.brandcampaigntemplates";
            this.draftTemplatesUrl = this.getUrlFromState(brandCampaignTemplates);

            const brandCampaignTemplatesPublished = "app.brandcampaigntemplates.published";
            this.publishedTemplatesUrl = this.getUrlFromState(brandCampaignTemplatesPublished);

            const brandCampaignTemplatesArchived = "app.brandcampaigntemplates.archived";
            this.archivedTemplatesUrl = this.getUrlFromState(brandCampaignTemplatesArchived);

            const manageTargetSources = "app.brandcampaigntemplates.targetsources";
            this.manageTargetSourcesUrl = this.getUrlFromState(manageTargetSources);

            const userHasPermission = this.permissionService.doesUserHavePermissionForContext(
                Dashboard.Models.Lookups.Permissions.CampaignDesignerAccess);

            this.showCampaignDesignerCard = userHasPermission && (this.draftTemplatesUrl
                || this.publishedTemplatesUrl
                || this.archivedTemplatesUrl
                || this.manageTargetSourcesUrl);
        }

        loadOrdersUrls() {
            const permissions = Dashboard.Models.Lookups.Permissions;
            const hasOrderAccessPermission = this.permissionService.doesUserHavePermissionForContext(
                permissions.OrdersAccess
            );
            const hasViewOnlineOrdersPermission = this.permissionService.doesUserHavePermissionForContext(
                permissions.ViewOnlineOrders
            );
            const hasBrandCustomerSupportPermission = this.permissionService.doesUserHavePermissionForContext(
                permissions.BrandCustomerSupportAgent
            );

            const orderUp = "app.orderup";
            const orderUpUrl = this.getUrlFromState(orderUp)
            const canShowOrderUpUrl = orderUpUrl && hasViewOnlineOrdersPermission;
            this.orderUpUrl = orderUpUrl;
            this.showOrderUp = canShowOrderUpUrl

            this.showBrandOrdersUrl = false;
            this.showStoreOrdersUrl = false;
            const context = this.permissionService.userContext;

            if (context.isBrandContext()) {
                const brandOrders = "app.brandorders";
                const brandOrdersUrl = this.getUrlFromState(brandOrders);
                this.showBrandOrdersUrl = brandOrdersUrl
                    && hasBrandCustomerSupportPermission
                    || hasOrderAccessPermission;
                this.brandOrdersUrl = brandOrdersUrl;
            }
            if (context.isStoreContext()) {
                const storeOrders = "app.storeorders";
                const storeOrdersUrl = this.getUrlFromState(storeOrders);
                this.showStoreOrdersUrl = storeOrdersUrl && hasOrderAccessPermission;
                this.storeOrdersUrl = storeOrdersUrl;
            }
            this.showOrdersCard = canShowOrderUpUrl
                || this.showBrandOrdersUrl
                || this.showStoreOrdersUrl
        }

        loadVouchersUrls() {
            const voucherRequest = "app.voucherrequest";
            const voucherRequestUrl = this.getUrlFromState(voucherRequest);
            this.voucherRequestUrl = voucherRequestUrl;
            const userHasPermission = this.permissionService.doesUserHavePermissionForContext(
                Dashboard.Models.Lookups.Permissions.ManageCampaigns);
            this.showVouchersCard = userHasPermission && voucherRequestUrl;
        }

        loadRestaurantUrls() {
            const settings = "app.storesettings";
            const settingsUrl = this.getUrlFromState(settings);
            const settingsPermission = this.permissionService
                .doesUserHavePermissionForContext(Dashboard.Models.Lookups.Permissions.StoreSettings);
            this.settingsUrl = settingsPermission ? settingsUrl : undefined;

            const outOfStockPermission = this.permissionService
                .doesUserHavePermissionForContext(Dashboard.Models.Lookups.Permissions.OutOfStock);
            const outOfStock = "app.storeoutofstock"
            this.outOfStockUrl = outOfStockPermission ? this.getUrlFromState(outOfStock) : undefined;

            const manageDeliveryZonesPermission = this.permissionService
                .doesUserHavePermissionForContext(Dashboard.Models.Lookups.Permissions.ManageDeliveryZones);
            const deliveryZones = "app.deliveryzones";
            this.deliveryZonesUrl = manageDeliveryZonesPermission
                ? this.getUrlFromState(deliveryZones)
                : undefined;

            this.showRestaurantCard =
                this.settingsUrl
                || this.outOfStockUrl
                || this.deliveryZonesUrl;
        }

        loadUsersUrls() {
            this.usersUrl = this.getUsersUrl();
            const hasViewUsersPermission = this.permissionService
                .doesUserHavePermissionForContext(
                    Dashboard.Models.Lookups.Permissions.ViewUsers);
            this.showUsersUrl = this.showUsersCard = hasViewUsersPermission
                && !!this.usersUrl;
        }

        getUsersUrl() {
            const context = this.permissionService.userContext;
            const isCallCenterContext = context.isCallCenterContext();
            const isStoreContext = context.isStoreContext();
            if (!isCallCenterContext
                && !isStoreContext) {
                return null;
            }
            const state = isCallCenterContext
                ? "app.callcenterusers"
                : "app.storeusers";
            return this.getUrlFromState(state);
        }

        loadUrls() {
            if (!this.permissionService.userContext) {
                return;
            }
            this.reportsURL = this.permissionService.doesUserHavePermissionForContext(
                Dashboard.Models.Lookups.Permissions.ReportsAccess)
                ? this.dashboardConfig.ReportioUrl
                : "";
            this.loadCampaignUrls();
            this.loadCampaignDesignerUrls();
            this.loadOrdersUrls();
            this.loadVouchersUrls();
            this.loadRestaurantUrls();
            this.loadUsersUrls();
        }

        initialise() {
            this.$scope.$on(Dashboard.Events.UserContextChanged, this.loadUrls.bind(this));
            this.permissionService.$initialised.then(this.loadUrls.bind(this));
        }
    }

    angular
        .module("dashboard")
        .component("home",
            {
                templateUrl: "components/home/home.a47461e7.html",
                bindings: {},
                controller: [
                    "$scope",
                    "$state",
                    "PermissionService",
                    "DashboardConfig",
                    "ChatAssistantSelector",
                    HomeComponent
                ]
            });
})();
